import { useEffect, useRef } from 'react';

const WebSocketComponent = () => {
  const ws = useRef(null);

  useEffect(() => {
    ws.current = new WebSocket('wss://syndays.fr/ws/');

    ws.current.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("WebSocket data:", data);
      // traite ici les données reçues
    };

    ws.current.onerror = (err) => {
      console.error("WebSocket error:", err);
    };

    return () => {
      if (ws.current && ws.current.readyState === WebSocket.OPEN) {
        ws.current.close();
      }
    };
  }, []);

  return null;
};

export default WebSocketComponent;
